<template>
  <v-theme-provider light>
    <div class="section-request-demo grey lighten-4" style="padding-top: 100px; padding-bottom: 60px;">
      <v-container class="py-12">
        <v-row class="text-center" align="center">
          <v-col>
            <p class="font-weight-medium display-2 grey--text text--darken-3">
              <v-icon class="blink" color="primary">mdi-color-helper</v-icon>Get Started <span class="font-weight-bold white--text primary">Now!</span>
            </p>
            <v-divider width="100" style="margin: auto;"></v-divider>
            <p class="mt-6 grey--text text--darken-3">
              We believe we have created the most efficient Vulnerability Intelligence platform. <br/>
              Try Free-Trial today and raise your vulnerability management program at a higher level.
            </p>

          </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            <v-btn raised elevation="4" color="primary" to="/login">Create an account and subscribe<v-icon right>mdi-arrow-right-bold</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecCreateAccount"
};
</script>
